import { useState } from 'react';
import { createRadarAlert } from './customerRadarApi.js';

/**
 * Botão "Avise-me quando chegar" para produto esgotado.
 * Aparece apenas quando o Radar está ligado e o cliente está autenticado.
 *
 * @param {{ slug: string, token: string, productId: number, productName?: string }} props
 */
export function RestockNotifyButton({ slug, token, productId, productName }) {
  const [state, setState] = useState('idle'); // idle | busy | done | error

  async function notify() {
    setState('busy');
    try {
      await createRadarAlert(slug, token, { productId, term: productName });
      setState('done');
    } catch {
      setState('error');
    }
  }

  if (state === 'done') {
    return (
      <p className="mt-1 inline-flex items-center gap-1 rounded-lg bg-emerald-500/15 px-2 py-1 text-[11px] font-semibold text-emerald-800 dark:text-emerald-200">
        ✓ Vamos avisar você por e-mail
      </p>
    );
  }

  return (
    <button
      type="button"
      disabled={state === 'busy'}
      onClick={notify}
      className="mt-1 inline-flex items-center gap-1.5 rounded-lg border border-[rgb(var(--st-rgb)/0.4)] bg-[rgb(var(--st-rgb)/0.08)] px-2.5 py-1 text-[11px] font-semibold text-[rgb(var(--st-rgb))] transition hover:bg-[rgb(var(--st-rgb)/0.16)] disabled:opacity-50"
    >
      {state === 'busy' ? 'A registar…' : state === 'error' ? 'Tente de novo' : '🔔 Avise-me quando chegar'}
    </button>
  );
}
